import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Widget from '../../../../components/widget';
import Loading from '../../../../components/loading';

import { handleError } from '../../../../actions/handle-error';
import { toastError } from '../../../../actions/toast';
import {
  floatToTimeList,
  formatDateToDashboard,
} from '../../../../actions/util';
import api from '../../../../actions/api';

class Index extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      header_table: [],
      data: [],
    };
  }

  componentDidMount() {
    const { budget_id } = this.props.match.params;
    const { crop_id } = this.props.match.params;

    const params = {
      budget_id: budget_id,
      crop_id: crop_id,
    };

    this.getIrrigation(params);
  }

  getIrrigation = async params => {
    await api
      .get(`dashboard/irrigations/datails`, { params })
      .then(result => {
        const data_ = result.data;

        if (data_.length > 0) {
          this.getHeaderTable(data_[0]);
        }

        this.setState({ loading: false, data: data_ });
      })
      .catch(error => {
        toastError(handleError(error));
      });
  };

  getHeaderTable = data => {
    let header_table_ = [{ label: 'Mês' }];

    for (let i = 0; i < data.crops.length; i++) {
      let item = data.crops[i];
      header_table_.push({ label: item.name });
    }

    header_table_.push({ label: 'Total Geral' });

    this.setState({ header_table: header_table_ });
  };

  rowTotalStyle = data => {
    const style = {
      backgroundColor: '#98c884',
      fontWeight: 'bold',
    };
    if (data.month === 'total') return style;

    return null;
  };

  render() {
    const irrigation = this.state;

    return (
      <Widget title="Irrigações">
        <div className="row">
          <div className="col">
            {irrigation.loading && (
              <div className="row justify-content-center mt-5">
                <Loading />
              </div>
            )}

            {!irrigation.loading && (
              <div className="row mt-2">
                <div className="table-responsive">
                  <table className="table table-sm table-striped table-bordered table-hover">
                    <thead className="thead-report">
                      <tr>
                        {irrigation.header_table.map((item, i) => (
                          <th scope="col" key={i} className="text-center">
                            <span className="ref-month">{item.label}</span>
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {irrigation.data.map((data, y) => (
                        <tr key={y} style={this.rowTotalStyle(data)}>
                          <td>{formatDateToDashboard(data.month)}</td>
                          {data.crops.map((crop, x) => (
                            <td key={x}>{floatToTimeList(crop.value)}</td>
                          ))}
                          <td>{floatToTimeList(data.total)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <form onSubmit={this.submit}>
              <div className="row no-gutters justify-content-end">
                <div className="col col-md-2 mt-3">
                  <Link to="/">
                    <button className="btn btn-success btn-block">
                      Voltar
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Widget>
    );
  }
}

export default Index;
